import copyIcon from "../../../assets/icons/copy.svg";
import editIcon from "../../../assets/icons/edit.svg";

const tableConfig = {
  cashoutTransactions: {
    columns: [
      {
        field: "date",
        label: "Date",
        type: "text",
      },
      {
        field: "description",
        label: "Description",
        path: "path",
        type: "link",
      },
      {
        field: "amount",
        label: "Amount",
        type: "text",
      },
    ],
    compact: true,
    url: "/admin/solvers/cashouts/transactions",
  },
  challengeDrafts: {
    columns: [
      {
        field: "title",
        label: "Title",
        path: "contestPathRelative",
        type: "link",
      },
      {
        field: "company",
        label: "Company",
        path: "companyPathRelative",
        type: "link",
      },
      {
        field: "contact",
        label: "Contact",
        type: "text",
      },
      {
        field: "launchDate",
        label: "Launch date",
        type: "text",
      },
      {
        field: "majorCategory",
        label: "Major category",
        type: "text",
      },
      {
        field: "tags",
        label: "Tags",
        type: "text",
      },
      {
        field: "hidden",
        label: "Hidden/internal",
        type: "text",
      },
      {
        field: "manager",
        label: "Account manager",
        type: "text",
      },
      {
        actions: [
          {
            icon: editIcon,
            path: "contestEditPathRelative",
            title: "Edit",
          },
          {
            icon: copyIcon,
            path: "contestClonePathRelative",
            title: "Clone",
          },
        ],
        label: "Actions",
        type: "actions",
      },
    ],
    withPagination: true,
    withSearch: {
      inputPlaceholder: "Search challenges...",
    },
    url: "/admin/contests/tables/challenge_drafts",
  },
  challengeStatistics: {
    columns: [
      {
        dashboard: "dashboard_path",
        field: "title",
        label: "Title",
        path: "contestPathRelative",
        type: "link",
      },
      {
        field: "company",
        label: "Company",
        path: "companyPathRelative",
        type: "link",
      },
      {
        field: "managerEmail",
        label: "Manager email",
        type: "text",
      },
      {
        field: "complete",
        label: "Complete",
        type: "text",
      },
      {
        field: "reviewed",
        label: "Reviewed",
        type: "text",
      },
      {
        field: "pageViewsCount",
        label: "Page views",
        type: "text",
      },
      {
        field: "solutionsCount",
        label: "Solutions",
        type: "text",
      },
      {
        field: "draftsCount",
        label: "Drafts",
        type: "text",
      },
      {
        field: "newSolversCount",
        label: "New solvers",
        type: "text",
      },
      {
        field: "repeatSolversCount",
        label: "Repeat solvers",
        type: "text",
      },
    ],
    withPagination: true,
    url: "/admin/contests/tables/challenge_statistics",
  },
  companyInvoices: {
    columns: [
      {
        field: "email",
        label: "Invoice recipient",
        type: "text",
        width: "60%",
      },
      {
        field: "amount",
        label: "Amount",
        type: "text",
        width: "20%",
      },
      {
        field: "paid",
        label: "Paid?",
        type: "text",
        width: "20%",
      },
    ],
    compact: true,
    withPagination: true,
    url: "/admin/companies/invoices",
  },
  demographicsAges: {
    columns: [
      {
        field: "value",
        label: "Ages",
        span: 3,
        type: "text",
        width: "60%",
      },
      {
        field: "count",
        type: "text",
        width: "20%",
      },
      {
        field: "percent",
        type: "text",
        width: "20%",
      },
    ],
    compact: true,
    url: "/admin/solvers/demographics/age",
  },
  demographicsCountries: {
    columns: [
      {
        field: "value",
        label: "Countries",
        span: 3,
        type: "text",
        width: "60%",
      },
      {
        field: "count",
        type: "text",
        width: "20%",
      },
      {
        field: "percent",
        type: "text",
        width: "20%",
      },
    ],
    compact: true,
    download: {
      mode: "admin",
      options: [
        {
          label: "Submitted solutions",
          name: "with_submitted_solutions",
          type: "checkbox",
        },
        {
          label: "Won money",
          name: "with_money_won",
          type: "checkbox",
        },
        {
          label: "LinkedIn profile",
          name: "with_linkedin",
          type: "checkbox",
        },
      ],
      position: "inline",
      select: {
        name: "countries",
        value: "count",
      },
      url: "/api/v1/admin/solvers/demographics/export",
    },
    url: "/admin/solvers/demographics/countries",
  },
  demographicsEthnicities: {
    columns: [
      {
        field: "value",
        label: "Ethnicities",
        span: 3,
        type: "text",
        width: "60%",
      },
      {
        field: "count",
        type: "text",
        width: "20%",
      },
      {
        field: "percent",
        type: "text",
        width: "20%",
      },
    ],
    compact: true,
    url: "/admin/solvers/demographics/ethnicity",
  },
  demographicsGenders: {
    columns: [
      {
        field: "value",
        label: "Genders",
        span: 3,
        type: "text",
        width: "60%",
      },
      {
        field: "count",
        type: "text",
        width: "20%",
      },
      {
        field: "percent",
        type: "text",
        width: "20%",
      },
    ],
    compact: true,
    url: "/admin/solvers/demographics/gender",
  },
  salesChallenges: {
    columns: [
      {
        field: "title",
        label: "Title",
        path: "contestPathRelative",
        type: "link",
      },
      {
        field: "company",
        label: "Company",
        path: "companyPathRelative",
        type: "link",
      },
      {
        field: "contact",
        label: "Contact",
        type: "text",
      },
      {
        field: "launchDate",
        label: "Launch date",
        type: "text",
      },
      {
        field: "majorCategory",
        label: "Major category",
        type: "text",
      },
      {
        field: "tags",
        label: "Tags",
        type: "text",
      },
      {
        field: "hidden",
        label: "Hidden/internal",
        type: "text",
      },
      {
        field: "manager",
        label: "Account manager",
        type: "text",
      },
      {
        actions: [
          {
            icon: editIcon,
            path: "contestEditPathRelative",
            title: "Edit",
          },
          {
            icon: copyIcon,
            path: "contestClonePathRelative",
            title: "Clone",
          },
        ],
        label: "Actions",
        type: "actions",
      },
    ],
    withSearch: {
      inputPlaceholder: "Search challenges...",
    },
    withPagination: true,
    url: "/admin/sales/challenges",
  },
  salesOpportunities: {
    columns: [
      {
        field: "firstName",
        label: "First name",
        type: "text",
      },
      {
        field: "lastName",
        label: "Last name",
        type: "text",
      },
      {
        field: "email",
        label: "Email",
        path: "userPathRelative",
        type: "link",
      },
      {
        field: "company",
        label: "Company",
        type: "text",
      },
      {
        field: "output",
        label: "Expected output",
        type: "text",
      },
      {
        field: "supervisorName",
        label: "Supervisor",
        type: "text",
      },
      {
        actions: [
          {
            label: "View form >",
            path: "viewFormPathRelative",
            title: "View",
          },
        ],
        label: "Actions",
        type: "actions",
      },
    ],
    compact: true,
    withPagination: true,
    url: "/admin/sales/opportunities",
  },
};

export { tableConfig };
